export default "__VITE_ASSET__KP3f8m6A__"